import { Component, OnDestroy, OnInit, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterOutlet } from '@angular/router';
import { LoadingBarComponent } from '@base/components/loading-bar';
import { MediaWatcherService } from '@base/services/media-watcher';
import { Subject, takeUntil } from 'rxjs';
import { NavbarComponent } from './navbar/navbar.component';
import { NavigationItemsComponent } from './navigation-items/navigation-items.component';

@Component({
  selector: 'vertical-layout',
  templateUrl: './vertical.component.html',
  styleUrl: './vertical.component.scss',
  imports: [
    LoadingBarComponent,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatListModule,
    MatRippleModule,
    NavbarComponent,
    RouterOutlet,
    MatToolbarModule,
    MatSidenavModule,
    NavigationItemsComponent,
  ],
})
export class VerticalLayoutComponent implements OnInit, OnDestroy {
  readonly sidenav = viewChild(MatSidenav);

  isScreenSmall: boolean;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(private _mediaWatcherService: MediaWatcherService) {}

  toggleSidenav(): void {
    this.sidenav()?.toggle();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to media changes
    this._mediaWatcherService.onMediaChange$.pipe(takeUntil(this._unsubscribeAll)).subscribe(({ matchingAliases }) => {
      // Check if the screen is small
      this.isScreenSmall = !matchingAliases.includes('md');
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
